import { render, staticRenderFns } from "./common-image-uploader.vue?vue&type=template&id=4cbcf82e&scoped=true"
import script from "./common-image-uploader.vue?vue&type=script&lang=js"
export * from "./common-image-uploader.vue?vue&type=script&lang=js"
import style0 from "./common-image-uploader.vue?vue&type=style&index=0&id=4cbcf82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbcf82e",
  null
  
)

export default component.exports